module.exports = __webpack_public_path__ + "media/AUDIO 01.43a56156.mp3";